<template>
  <div class="certify-box">
    <div class="back-logo" @click="backBtn"><i class="el-icon-back"> </i></div>
    <div class="certify_box_title">验证独立密码</div>
    <div class="certify_box_intro">
      您的账号已开启独立密码保护，请输入您的独立密码
    </div>
    <div class="certify-wrap">
      <el-input
        v-model="uin"
        type="text"
        class="certify-number"
        :disabled="true"
      >
        <i slot="prefix" class="account"></i>
      </el-input>
      <el-input v-model="password" type="password" class="certify-password">
        <i slot="prefix" class="pass"></i>
      </el-input>
    </div>
    <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    <div class="error-message" v-else><br /></div>
    <el-button @click="login" type="warning" class="login_btn">登录</el-button>
    <div class="certify-dialog-bottom">如忘记密码请向室长索要</div>
  </div>
</template>

<script>
import { isCertify } from '@/api/common';
import { encryptPwd } from '@/utils/crypto';
import store from '../store';
export default {
  data() {
    return {
      errorMessage: '',
      uin: this.$route.params.uin,
      password: '',
    };
  },
  methods: {
    backBtn() {
      sessionStorage.clear();
      this.$router.push({ name: 'Login' });
    },
    login() {
      if (!this.password) {
        this.errorMessage = '请输入独立密码';
      } else {
        this.errorMessage = '';
        this.loginFn();
      }
    },
    //密码格式符合要求
    async loginFn() {
      let data = {
        uin: this.uin,
        second_pwd: encryptPwd(this.password),
      };
      //测试
      //this.$router.push('/');
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
      if (userInfo.loginFormUrl) {
        const res = await isCertify(data);
        if (res.code === 0) {
          sessionStorage.setItem('token2', res.data);
          sessionStorage.setItem('setible', true);
          userInfo.loginFormUrl = false;
          //  location.href = location.href.split('?')[0]
          store.commit('SET_USER_INFO', userInfo);
          // sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
          this.$router.push('/');
        } else {
          this.$message.error('请输入正确的密码');
        }
      } else {
        const res = await isCertify(data);
        if (res.code === 0) {
          sessionStorage.setItem('token2', res.data);
          sessionStorage.setItem('setible', true);
          this.$router.push('/', () => location.reload()); //,() => location.reload()
        } else {
          this.$message.error('请输入正确的密码');
        }
      }
      //  const res=await isCertify(data);
      // 跳转到首页
      /*   if(res.code===0){
        sessionStorage.setItem('token2',res.data);
        sessionStorage.setItem('setible',true);
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        if (userInfo.loginFormUrl) {
          userInfo.loginFormUrl = false;
          location.href = location.href.split('?')[0]
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
        } else {
          this.$router.push('/',() => location.reload());//,() => location.reload()
        }
      }
      else{
        this.$message.error('请输入正确的密码')
      }   */
    },
  },
};
</script>
<style lang="scss" scoped>
.certify-box {
  position: relative;
  top: 201px;
  left: 50%;
  margin-left: -175px;
  width: 350px;
  height: 400px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 8px;
}
.back-logo {
  top: 0;
  position: absolute;
  margin-left: 6px;
  font-size: 30px;
  color: rgba(38, 38, 38, 1);
}
.certify_box_title {
  //width: 120px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 40px;
  color: rgba(38, 38, 38, 1);
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
}
.certify_box_intro {
  text-align: center;
  margin-left: 36px;
  margin-top: 24px;
  margin-right: 31px;
  color: #595959;
  font-size: 16px;
  line-height: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.el-input {
  width: 282px;
  height: 40px;
  // border: 1px solid #979797;
  border-radius: 8px;
  margin: 30px 32px 0 36px;
  font-size: 16px;
}

.error-message {
  font-size: 14px;
  color: #f7424e;
  margin-left: 36px;
  //margin-left:35%;
  //margin-bottom:px;
  margin-top: 5px;
}
.login_btn {
  width: 282px;
  height: 40px;
  margin: 5px 32px 32px 36px;
  font-size: 18px;
  border-radius: 8px;
  position: absolute;
}
.certify-dialog-bottom {
  margin-top: 60px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #bfbfbf;
  line-height: 28px;
}
.account {
  background: url('~@/assets/images/ico_account.svg') no-repeat;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: block;
  margin-top: 11px;
}
.pass {
  background: url('~@/assets/images/ico_password.svg') no-repeat;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: block;
  margin-top: 11px;
}
</style>
